const NAVBAR_WIDTH_EXPANDED = 278;

export function useNavbarWidth() {
    return {
        expanded: NAVBAR_WIDTH_EXPANDED,
        collapsed: 0,
    };
}
